(ns quuppa.ui.util)

(def TEXT-COLORS
  ["text-primary"
   "text-secondary"
   "text-success"
   "text-danger"
   "text-warning"
   "text-info"
   "text-light"
   "text-dark"
   "text-muted"
   "text-white"])

(def VARIANTS
  ["primary"
   "secondary"
   "success"
   "danger"
   "warning"
   "info"
   "light"
   "dark"
   "link"])

(defn parse-args [args]
  (if (map? (first args))
    [(first args) (rest args)]
    [nil args]))
